import { render, staticRenderFns } from "./managementAdd.vue?vue&type=template&id=2dc07150&scoped=true&"
import script from "./managementAdd.vue?vue&type=script&lang=js&"
export * from "./managementAdd.vue?vue&type=script&lang=js&"
import style0 from "./managementAdd.vue?vue&type=style&index=0&id=2dc07150&scoped=true&lang=css&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc07150",
  null
  
)

export default component.exports